import {
  Button,
  Typography,
  Avatar,
  Box,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSelector } from "react-redux";

const SuccessVisitorDialog = ({
  handleClose,
  mode,
  checkOutInfo,
}) => {
  const { visitors_data } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
  let user = visitors_data?.find(
    (el) => el?.visitors_management_pk === checkOutInfo?.checkOutId
  );
  const formatTime = (date) => {
    const time = new Date(date);
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return time.toLocaleTimeString("en-US", {
      ...options,
      timeZone: "UTC",
    });
  };

  const theme = createTheme({
    typography: {
      fontSize: 20,
      h6: {
        fontSize: 20,
        "@media (min-width:600px)": {
          fontSize: 35,
        },
        "@media (min-width:960px)": {
          fontSize: 26,
        },
      },
      body1: {
        fontSize: 20,
        "@media (min-width:600px)": {
          fontSize: 30,
        },
        "@media (min-width:960px)": {
          fontSize: 24,
        },
        display: "flex",
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Box 
        className= "visitors-bg"
        sx={{width: { xs: "90%", sm: "80%", md:"50%" }, borderRadius: "10px"}}>
        <Box
       
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            margin: "50px 0px 10px 0px",
          }}
        >
          <CheckCircleIcon
            sx={{ color: "#fecb03", fontSize: { xs: 30, sm: 40, md: 35 } }}
          />
          <Typography variant="h6">{`${mode} Successful`}</Typography>
        </Box>

        <Box
          sx={{
            display:"flex",
            flexDirection: "column", 
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Avatar
              src={checkOutInfo?.url}
              alt={user?.visitors_name}
              sx={{
                width: { xs: 100, sm: 150, md: 140 },
                height: { xs: 100, sm: 150, md: 140 },
              }}
            />
            <Typography variant="h6" color={"#883bd5"} fontWeight={"bold"}>
              {user?.visitors_name}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              gap: 1,
              marginTop: "20px",
              textAlign: "start",
            }}
          >
            {[
              { label: "Host", value: user?.employee_name || "NA" },
              { label: "Purpose", value: user?.reason || "NA" },
              {
                label: "Check-In",
                value: user?.checkin_timestamp
                  ? formatTime(user?.checkin_timestamp)
                  : "NA",
              },
              {
                label: "Check-Out",
                value: user?.checkout_timestamp
                  ? formatTime(user?.checkout_timestamp)
                  : "NA",
              },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ flex: "1 0 52%", fontWeight: "bold" }}
                >
                  {item.label}
                </Typography>
                <Typography variant="body2" sx={{ flex: "0 0 3%" }}>
                  :
                </Typography>
                <Typography variant="body2" color={"#883bd5"} sx={{ flex: "1 0 45%" }}>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            size="small"
            sx={{
              width: { xs: "100px", sm: "120px", md: "100px" },
              fontWeight: "bold",
              margin: "20px 0px",
              borderRadius: "10px",
              color: "black",
              background: "#fecb03",
              border: "1px solid #fecb03",
              transition: "all 0.3s ease",
              "&:hover": {
                cursor: "pointer",
                backgroundColor: "#fecb03",
                boxShadow: "0px 4px 10px rgba(254,203,3, 0.3)",
              },
            }}
            onClick={handleClose}
          >
            OK
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default SuccessVisitorDialog;
